import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import SectionTitle from "../SectionTitle";
import { collection, getDocs, query, orderBy , db} from "../../api/firebaseConfig.js";
import SearchBarProject from "../SearchBarProject.jsx";

const ProjectSectionS2 = ({ titre }) => {
  const [posts, setPosts] = useState([]);
  const [path, setPath] = useState("");
  const [filteredPosts, setFilteredPosts] = useState([]);
  const [searchParams] = useSearchParams();
  const searchQuery = searchParams.get("query") || "";

  useEffect(() => {
    const fetchPostsRiadRenove = async () => {
      try {
        const q = query(collection(db, "blogPosts"), orderBy("createdAt", "desc"));
        const querySnapshot = await getDocs(q);
        const postsList = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          imageprincipale: doc.data().imageprincipale,
          title: doc.data().title,
        }));
        setPosts(postsList);
      } catch (error) {
        console.error("Error fetching posts: ", error);
      }
    };

    const fetchPostsRiadArenover = async () => {
        try {
          const q = query(collection(db, "blogPostsRiadArenover"), orderBy("createdAt", "desc"));
          const querySnapshot = await getDocs(q);
          const postsList = querySnapshot.docs.map((doc) => ({
            id: doc.id,
            imageprincipale: doc.data().imageprincipale,
            title: doc.data().title,
          }));
          setPosts(postsList);
        } catch (error) {
          console.error("Error fetching posts: ", error);
        }
      };

     if(titre=="Riads Rénovés"){
        setPath("riads-renove")
        fetchPostsRiadRenove()

     }else{
        setPath("riads-a-renover")
        fetchPostsRiadArenover()
     }
  }, [titre]);





  useEffect(() => {
    const filtered = posts.filter((post) =>
      post.title.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredPosts(filtered);
  }, [searchQuery, posts]);

  return (
    <div className="wpo-project-area-s2 section-padding">
      <div className="container">
        <SectionTitle subTitle={`Nos Projets des ${titre}`} MainTitle={"Nos Projets Récents "} />
        <div className="row align-items-center">
          <div className="mb-4">
            <SearchBarProject showType={false} />
          </div>
          <div className="wpo-project-wrap">
            <div className="sortable-gallery">
              <div className="row">
                <div className="col-lg-12">
                  <div className="project-grids gallery-container clearfix">
                    {filteredPosts.length > 0 ? (
                      filteredPosts.map((project, index) => (
                        <div className="grid" key={index}>
                          <div className="wpo-project-item">
                            <div className="wpo-project-img">
                              <img src={project.imageprincipale} alt={project.title} />
                              <div className="left-border"></div>
                              <div className="right-border"></div>
                            </div>
                            <div className="wpo-project-text">
                              <h2>
                                <Link to={`/${path}/${project.id}`}>{project.title}</Link>
                              </h2>
                            </div>
                          </div>
                        </div>
                      ))
                    ) : (
                      <p className="text-center">Aucun projet trouvé</p>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProjectSectionS2;
